import { Box, Popover, styled } from '@mui/material';

export const SubMenuContainer = styled(Popover, {
  shouldForwardProp: (prop) => prop !== 'width',
})(({ theme, width }) => ({
  '& .MuiPaper-root': {
    width,
    border: `1px solid ${theme.palette.colors.mainFocused}`,
    borderRadius: '5px',
    padding: '8px 8px 8px 5px',
    backgroundColor: theme.palette.colors.secondaryBackground,
    marginTop: '4px',
  },
}));

export const SubMenuOption = styled(Box)(({ theme }) => ({
  color: theme.palette.colors.onSecondaryAndDetailBackground,
  fontSize: '12px',
  fontWeight: 500,
  lineHeight: 'normal',
  letterSpacing: 'normal',
  textTransform: 'uppercase',
  padding: '9px 0 8px 11px',

  '&:hover': {
    cursor: 'pointer',
    backgroundColor: theme.palette.colors.selectedAndDetailBackground,
    borderRadius: '5px',
  },

  '&:not(:first-of-type)': {
    marginTop: '4px',
  },
}));
